module.exports = __webpack_public_path__ + "img/visa.cd4d2397.jpg";